import React from "react";
import { tabKeyword } from "../../config/constants";
import { tabProps } from "../../interfaces/Interface";

const tabObj: tabProps[] = [
  {
    id: 1,
    name: tabKeyword.Reading,
  },
  {
    id: 2,
    name: tabKeyword.Speaking,
  },
];
type TabsProps = {
  currentTab: number;
  tabClick: (arg: tabProps) => void;
};
const Tab = (props: TabsProps) => {
  const { tabClick, currentTab } = props;
  const onTabClick = (item: tabProps) => {
    tabClick && tabClick(item);
  };
  return (
    <div
      className="flex items-center px-4 py-[2px] z-20 relative"
      aria-label="main navigation"
      role="navigation"
    >
      {tabObj.map((item: tabProps, index: number) => {
        return (
          <nav
            key={item.id}
            className="flex items-center"
            aria-label={`${item.name} tab`}
          >
            <div
              onClick={() => onTabClick(item)}
              className={`${
                currentTab === item.id
                  ? "border-b-[3px] border-[#1e3a8a] text-[#1e3a8a] font-bold "
                  : "text-[#1e3a8a]"
              } text-sm py-1 px-3 cursor-pointer`}
              tabIndex={0}
              onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
                if (event.key === "Enter") {
                  onTabClick(item);
                }
              }}
            >
              <div>{item.name}</div>
            </div>
            {tabObj.length - 1 !== index && (
              <div className="h-4 w-[2px] bg-gray-300 mx-4"></div>
            )}
          </nav>
        );
      })}
    </div>
  );
};

export default Tab;
